import { api } from '../lib/api';

export interface SiteRecord {
  id: number;
  parentId: number | null;
  parentName?: string | null;
  name: string;
  siteTypeItemId: number | null;
  siteTypeLabel?: string | null;
  address1: string | null;
  address2: string | null;
  postalCode: string | null;
  city: string | null;
  country: string | null;
  lat: string | number | null;
  lng: string | number | null;
  notes: string | null;
  isActive: number;
}

export interface SiteFormData {
  parentId?: number | null;
  name: string;
  siteTypeItemId?: number | null;
  address1?: string;
  address2?: string;
  postalCode?: string;
  city?: string;
  country?: string;
  lat?: string;
  lng?: string;
  notes?: string;
  isActive?: boolean;
}

export interface SitesMeta {
  siteTypes: Array<{ id: number; label: string }>;
  parents: Array<{ id: number; parentId: number | null; name: string; isActive: number }>;
}

export const sitesApi = {
  list: (includeInactive = false) =>
    api.get<{ sites: SiteRecord[] }>(includeInactive ? '/sites?includeInactive=1' : '/sites'),
  meta: () => api.get<SitesMeta>('/sites/meta'),
  get: (id: number) => api.get<SiteRecord>(`/sites/${id}`),
  create: (data: SiteFormData) => api.post<{ id: number; name: string }>('/sites', data),
  update: (id: number, data: SiteFormData) => api.patch<{ ok: boolean }>(`/sites/${id}`, data),
  delete: (id: number) => api.delete<{ ok: boolean }>(`/sites/${id}`),
};
